export default __webpack_public_path__ + "static/media/luci.506376bb.png";